export default "__VITE_ASSET__CLpyzXcV__"